import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { organizationsApi } from '../api/organizations';
import { queryKeys } from '../lib/queryKeys';
import type { PaginationParams } from '../types/api';
import type { AdminOrgUpdateRequest, AdminTransferOwnershipRequest } from '../types/organizations';

export function useOrgsList(params: PaginationParams) {
  return useQuery({
    queryKey: queryKeys.organizations.list(params),
    queryFn: () => organizationsApi.list(params),
  });
}

export function useOrgDetail(id: string) {
  return useQuery({
    queryKey: queryKeys.organizations.detail(id),
    queryFn: () => organizationsApi.detail(id),
    enabled: !!id,
  });
}

export function useUpdateOrg(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AdminOrgUpdateRequest) => organizationsApi.update(id, data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: queryKeys.organizations.detail(id) }); qc.invalidateQueries({ queryKey: queryKeys.organizations.all }); message.success('Organization updated'); },
  });
}

export function useTransferOwnership(id: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: AdminTransferOwnershipRequest) => organizationsApi.transferOwnership(id, data),
    onSuccess: () => { qc.invalidateQueries({ queryKey: queryKeys.organizations.detail(id) }); message.success('Ownership transferred'); },
  });
}
